import React, { FC } from 'react';

import { AnimatedNumber } from './animated-number';

export type AnimatedDisplayValueProps = {
  className?: string;
  emptyDisplay?: string;
  multiply?: number;
  prefix?: string;
  roundTo?: number;
  suffix?: string;
  value: null | number | undefined;
};

// Animated counterpart of inline `formatDisplayValue`-style rendering: same
// prefix/suffix/multiply/round semantics, but the numeric part counts up via
// AnimatedNumber when the value changes in place (no remount).
export const AnimatedDisplayValue: FC<AnimatedDisplayValueProps> = ({
  className,
  emptyDisplay = '0',
  multiply = 1,
  prefix = '',
  roundTo = 2,
  suffix = '',
  value,
}) => {
  // Only absent data falls back to `emptyDisplay`; a real 0 still counts through AnimatedNumber.
  if (value === null || value === undefined || !Number.isFinite(value * multiply)) {
    return (
      <span className={className}>
        {prefix}
        {emptyDisplay}
        {suffix}
      </span>
    );
  }

  return (
    <span className={className}>
      {prefix}
      <AnimatedNumber maximumFractionDigits={roundTo} value={value * multiply} />
      {suffix}
    </span>
  );
};
